import React, { useEffect, useState } from "react";
import Filter from "../../../../assets/Icons/filter.png";
import ExcelExport from "../../../../compnenets/commons/xls";
import Modal from "react-responsive-modal";
import Close from "../../../../assets/Images/close.png";
import leftArrow from "../../../../assets/Images/left-arrow.png";
import rightArrow from "../../../../assets/Images/right-arrow.png";
import "../archival.css";
import { PROJECT_ARCHIVAL } from "../../../../services/apiCalls/archivalApiCalls";

export default function JobSpecificTraining({ project }) {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const [jobSpecificData, setJobSpecificData] = useState([]);
  const [filterData, setFilterData] = useState({
    ProjectID: project.project_id,
    StartDate: "",
    EndDate: "",
    TrainingTitle: "",
    TrainingConductedStatus: "",
    sortOrder: "ASC",
    sortBy: "Site Vist/Audit Date",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(jobSpecificData.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = jobSpecificData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const fetchArchivalJobSpecific = async (payload) => {
    let obj = payload;
    if (!payload) {
      obj = {
        ProjectID: project.project_id,
      };
    }
    const response = await PROJECT_ARCHIVAL.Get_JobSpecificTraining(obj);
    if (response && response.JobSpecificTrainingList?.length > 0) {
      setJobSpecificData(response.JobSpecificTrainingList);
    } else {
      setJobSpecificData([]);
    }
  };
  useEffect(() => {
    fetchArchivalJobSpecific();
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <React.Fragment>
      <Modal open={open} onClose={() => {}} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resources">Job specific training Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => setOpen(false)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Start Date</label>
                  <input
                    type="date"
                    name="StartDate"
                    value={filterData.StartDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End Date</label>
                  <input
                    type="date"
                    name="EndDate"
                    value={filterData.EndDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Training title</label>
                  <select
                    onChange={handleChange}
                    value={filterData?.TrainingTitle}
                    name="TrainingTitle"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                      color: "gray",
                      fontSize: 13,
                      paddingLeft: 10,
                    }}
                  >
                    <option value={""}>--Select--</option>
                    <option value={"Safety Induction"}>Safety Induction</option>
                    <option value={"Risk Assesment"}>Risk Assesment</option>
                    <option value={"Excavation Work"}>Excavation Work</option>
                    <option value={"Housekeeping 55"}>Housekeeping 55</option>
                    <option value={"Electrical Safety"}>
                      Electrical Safety
                    </option>
                    <option value={"Heigh work"}>Heigh work</option>
                    <option value={"Machanical Material"}>
                      Machanical Material
                    </option>
                    <option value={"Six directional hazard"}>
                      Six directional hazard
                    </option>
                    <option value={"Contractor"}>Contractor</option>
                    <option value={"Scaffolding safety"}>
                      Scaffolding safety
                    </option>
                    <option value={"PTW System"}>PTW System</option>
                    <option value={"Road Safety"}>Road Safety</option>
                    <option value={"Use of Power hand"}>
                      Use of Power hand
                    </option>
                    <option value={"BBS Training"}>BBS Training</option>
                    <option value={"Emergency Response"}>
                      Emergency Response
                    </option>
                    <option value={"Use of PPEs"}>Use of PPEs</option>
                    <option value={"Life Saving Rule"}>Life Saving Rule</option>
                    <option value={"Waste Management"}>Waste Management</option>
                    <option value={"Health and Hygiene"}>
                      Health and Hygiene
                    </option>
                  </select>
                  {/* <input
                  type="text"
                  name="TrainingTitle"
                  value={filterData.TrainingTitle}
                  onChange={handleChange}
                  className="form-control shadow-none"
                /> */}
                </div>
                <div className="col-6">
                  <label className="filter-label">
                    Training conducted status
                  </label>
                  <select
                    onChange={handleChange}
                    value={filterData?.TrainingConductedStatus}
                    name="TrainingConductedStatus"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                      color: "gray",
                      fontSize: 13,
                      paddingLeft: 10,
                    }}
                  >
                    <option value={""}>--Select--</option>
                    <option value={"YES"}>YES</option>
                    <option value={"NO"}>NO</option>
                    <option value={"NA"}>NA</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: 20 }}>
              <span className="resorces">Sort Job specific training</span>
            </div>
            <div style={{ marginRight: 20 }}>
              <select
                name="sortOrder"
                value={filterData.sortOrder}
                onChange={handleChange}
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option value="ASC">ASC</option>
                <option value="DES">DES</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginLeft: 20 }}>
          {["Date of training", "Created date", "Training Title"].map(
            (sortOption) => (
              <div className="form-check" key={sortOption}>
                <input
                  className="form-check-input shadow-none"
                  type="radio"
                  name="sortBy"
                  id={sortOption}
                  value={sortOption}
                  checked={filterData.sortBy === sortOption}
                  onChange={handleChange}
                />
                <label htmlFor={sortOption} style={{ fontSize: 14 }}>
                  {sortOption}
                </label>
              </div>
            )
          )}
        </div>

        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            className="btn btn-primary"
            onClick={() => {
              fetchArchivalJobSpecific(filterData);
              setCurrentPage(1);
              setOpen(false);
            }}
          >
            Filter
          </button>
        </div>
      </Modal>
      <div className="row">
        <div className="d-flex justify-content-end">
          <div className="download-icon">
            <ExcelExport
              data={jobSpecificData}
              fileName="Jobspecific"
              sheet="Jobspecific List"
            />
          </div>
          <div className="filter-icon mx-2 my-auto">
            <img
              className=""
              onClick={() => {
                setOpen(true);
              }}
              src={Filter}
              width={20}
            />
          </div>
          <div className="my-auto" onClick={() => fetchArchivalJobSpecific()}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
                background: "#8add79f7",
                padding: 5,
                borderRadius: 12,
              }}
            >
              Clear filters
            </span>
          </div>
        </div>
      </div>
      <div className="table-container-archival">
        <table id="custom-table-archival">
          <thead className="table-header-archival">
            <tr>
              <th>Sr No</th>
              <th>Project Name</th>
              <th>Date of Training</th>
              <th>Training Title</th>
              <th>Training Conducted</th>
              <th>Topic Covered</th>
              <th>Name of person</th>
              <th>Created Date</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index}>
                <td>{index + 1 + (currentPage - 1) * 10}</td>
                <td>{row.ProjectName}</td>
                <td>{new Date(row?.DateofTraining1).toLocaleDateString('en-GB')}</td>
                <td>{row.TrainingTitle}</td>
                <td>{row.TrainingConducted}</td>
                <td>{row.TopicCovered}</td>
                <td>{row.NameOfPersonTrainingGiven}</td>
                <td>{new Date(row?.CreatedOn).toLocaleDateString('en-GB')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        className="pagination"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 15px",
        }}
      >
        <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
          Showing{" "}
          {Math.min(
            (currentPage - 1) * rowsPerPage + 1,
            jobSpecificData.length
          )}{" "}
          to {Math.min(currentPage * rowsPerPage, jobSpecificData.length)} of{" "}
          {jobSpecificData.length} entries
        </div>

        <div
          className="pagination-buttons"
          style={{
            fontSize: "14px",
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            gap: "5px",
          }}
        >
          {/* Left Arrow */}
          <button
            onClick={() => handleClick(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={leftArrow} // Replace with your actual image path
              alt="Previous"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
            />
          </button>

          {/* Page Numbers */}
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => handleClick(i + 1)}
              style={{
                background: currentPage === i + 1 ? "#00B69B" : "transparent",
                color: currentPage === i + 1 ? "#fff" : "#000",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              {i + 1}
            </button>
          ))}

          {/* Right Arrow */}
          <button
            onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={rightArrow} // Replace with your actual image path
              alt="Next"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
            />
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}
